import _defineProperty from '@babel/runtime/helpers/defineProperty';

/* eslint-disable no-return-assign, prefer-rest-params, prefer-spread, @typescript-eslint/no-explicit-any */
function isPrimitive(value) {
  return typeof value !== 'object' && typeof value !== 'function' || value === null;
}
class MapTree {
  constructor() {
    _defineProperty(this, "childBranches", void 0);
    _defineProperty(this, "primitiveKeys", void 0);
    _defineProperty(this, "hasValue", void 0);
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "has", key => {
      const keyObject = isPrimitive(key) ? this.primitiveKeys.get(key) : key;
      return keyObject ? this.childBranches.has(keyObject) : false;
    });
    _defineProperty(this, "get", key => {
      const keyObject = isPrimitive(key) ? this.primitiveKeys.get(key) : key;
      return keyObject ? this.childBranches.get(keyObject) : undefined;
    });
    _defineProperty(this, "resolveBranch", key => {
      if (this.has(key)) {
        return this.get(key);
      }
      const newBranch = new MapTree();
      const keyObject = this.createKey(key);
      this.childBranches.set(keyObject, newBranch);
      return newBranch;
    });
    _defineProperty(this, "setValue", value => {
      this.hasValue = true;
      return this.value = value;
    });
    _defineProperty(this, "createKey", key => {
      if (isPrimitive(key)) {
        const keyObject = {};
        this.primitiveKeys.set(key, keyObject);
        return keyObject;
      }
      return key;
    });
    _defineProperty(this, "clear", (...args) => {
      if (args.length === 0) {
        this.childBranches = new WeakMap();
        this.primitiveKeys.clear();
        this.hasValue = false;
        this.value = undefined;
      } else if (args.length === 1) {
        const key = args[0];
        if (isPrimitive(key)) {
          const keyObject = this.primitiveKeys.get(key);
          if (keyObject) {
            this.childBranches.delete(keyObject);
            this.primitiveKeys.delete(key);
          }
        } else {
          this.childBranches.delete(key);
        }
      } else {
        const childKey = args[0];
        if (this.has(childKey)) {
          const childBranch = this.get(childKey);
          childBranch.clear.apply(childBranch, Array.prototype.slice.call(args, 1));
        }
      }
    });
    this.childBranches = new WeakMap();
    this.primitiveKeys = new Map();
    this.hasValue = false;
    this.value = undefined;
  }
}
function memoize(fn) {
  const argsTree = new MapTree();
  function memoized() {
    const args = Array.prototype.slice.call(arguments);
    const argNode = args.reduce((parentBranch, arg) => parentBranch.resolveBranch(arg), argsTree);
    if (argNode.hasValue) {
      return argNode.value;
    }
    const value = fn.apply(null, args);
    return argNode.setValue(value);
  }
  memoized.clear = argsTree.clear.bind(argsTree);
  return memoized;
}

export { memoize as m };
//# sourceMappingURL=memoizeWeak-282c0058-7439cd47.js.map
